import { NgTemplateOutlet } from '@angular/common';
import type { ElementRef, TemplateRef } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Renderer2,
  ViewChild,
  output,
} from '@angular/core';

import { DropdownHeaderComponent } from '../common/dropdown/dropdown-header/dropdown-header.component';
import { DropdownItemComponent } from '../common/dropdown/dropdown-item/dropdown-item.component';
import { DropdownComponent } from '../common/dropdown/dropdown.component';
import { IconComponent } from '../common/icon/icon.component';
import type { TooltipPosition } from '../common/tooltip/tooltip-inner.component';
import { RtTooltip } from '../common/tooltip/tooltip.directive';
import { ScrollableDirective } from '../core/overlay/scroll/scrollable.directive';
import type { IconName } from '../icons-container/icons.type';

export type DropdownItem<T = any> = {
  option: string;
  value: T;
  icon?: IconName;
  badgeTemplate?: TemplateRef<any>;
  disabled?: boolean;
  tooltip?: string;
  tooltipEnabled?: boolean;
  tooltipPosition?: TooltipPosition;
};

@Component({
  selector: 'rt-dropdown-scrollable',
  templateUrl: './dropdown-scrollable.component.html',
  styleUrls: ['./dropdown-scrollable.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DropdownComponent,
    DropdownHeaderComponent,
    DropdownItemComponent,
    IconComponent,
    ScrollableDirective,
    NgTemplateOutlet,
    RtTooltip,
  ],
})
export class DropdownScrollableComponent<T> {
  @Input() public items: Array<DropdownItem<T>>;
  @Input() public maxHeight: number = 200;
  @Input() public header: string;
  @Input() public icons: string[];

  public selectionChange = output<T>();

  @ViewChild('scrollWrap', { static: true }) private scrollWrap: ElementRef;

  constructor(private renderer: Renderer2) {}

  public ngOnInit(): void {
    this.setComponentHeight();
  }

  public trackByItem(index: number, item: DropdownItem): string {
    return item.value;
  }

  private setComponentHeight(): void {
    this.renderer.setStyle(this.scrollWrap.nativeElement, 'max-height', `${this.maxHeight}px`);
  }
}
